module.exports = __webpack_public_path__ + "img/zw.af2b9f27.png";